export default "__VITE_ASSET__BCEC9tJ6__"